module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-pt-PT.692b7a05.jpg";